<template>
	<v-text-field
		append-icon="fas fa-search"
		:label="$t(label)"
		single-line
		hide-details
		outlined
		clearable
		v-model="query"
		v-on:keyup.enter="onSearchEnter"
		@click:append="onSearchEnter"
	></v-text-field>
</template>

<script>
export default {
	name: 'SearchInput',
	props: {
		label: String,
		onSearch: {
			type: Function,
			required: true
		},
	},
	data: () => ({
		query: '',
	}),
	methods: {
		onSearchEnter() {
			this.onSearch({ query: this.query });
		}
	}
};
</script>